import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

interface GuildContextType {
  selectedGuildId: string | null;
  setSelectedGuildId: (guildId: string | null) => void;
}

const GuildContext = createContext<GuildContextType | undefined>(undefined);

export const GuildProvider = ({ children }: { children: ReactNode }) => {
  const [selectedGuildId, setSelectedGuildId] = useState<string | null>(null);

  return (
    <GuildContext.Provider value={{ selectedGuildId, setSelectedGuildId }}>
      {children}
    </GuildContext.Provider>
  );
};

export const useGuild = () => {
  const context = useContext(GuildContext);
  if (context === undefined) {
    throw new Error('useGuild must be used within a GuildProvider');
  }
  return context;
};
